import { KalturaWatchStatus } from '@kaltura-ott/ott-client-types/api/types';
import { getContinueWatchingRailV2, KuxFilteredCategoriesDTO, UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';
import { action } from 'mobx';
import { lastValueFrom } from 'rxjs';

import { CardPlaceholder, Program } from '../../../../entities';
import {
  addBookmarkToPlayable,
  addPurchasableAttribute,
  addRentalAttribute,
  creatorEntityStore,
} from '../../../../entities/entities.service';
import { PlayableAsset } from '../../../../entities/PlayableAsset';
import { getItemsInPage, DEFAULT_PAGE_SIZE } from '../rail-store-helper-v2';
import { RailStoreV2 } from '../rail-store-v2';

export class ContinueRailStoreV2 extends RailStoreV2<PlayableAsset> {
  subtype: UIDAPresentationTypeEnum.cw = UIDAPresentationTypeEnum.cw;
  private statusEqual: KalturaWatchStatus;
  private typeIn?: string;
  public readonly useSuppress?: boolean;
  private assetHistoryKSQL = '';

  constructor(categoryTree: KuxFilteredCategoriesDTO, parentCategoryTree: KuxFilteredCategoriesDTO, children?: []) {
    super(categoryTree, parentCategoryTree, children);
    this.statusEqual = categoryTree.continueWatchingProperty.statusEqual;
    this.typeIn = categoryTree.continueWatchingProperty.typeIn;
    this.useSuppress = categoryTree.continueWatchingProperty.useSuppress;

    this.assetHistoryKSQL = categoryTree.railProperty.enableFilterByEntitlement
      ? categoryTree.aggregatedKSQL.replace("entitled_assets='entitledSubscriptions'", '')
      : categoryTree.aggregatedKSQL;
  }

  protected async getData(
    pageIndex: number,
    items: (PlayableAsset | CardPlaceholder)[],
  ): Promise<{ items: (PlayableAsset | CardPlaceholder)[]; totalCount: number; newItems: PlayableAsset[] }> {
    const newRailData = await lastValueFrom(
      getContinueWatchingRailV2({
        pageSize: DEFAULT_PAGE_SIZE,
        pageIndex,
        kSql: this.aggregatedKSQL,
        assetHistoryKSQL: this.assetHistoryKSQL,
        groupBy: this.groupBy,
        typeIn: this.typeIn,
        statusEqual: this.statusEqual,
        suppress: this.useSuppress,
        isGroupedGrid: this.categoryTree.railProperty.isGroupedGrid,
      }),
    );

    const newItems = newRailData.items.slice(0, this.pageSize).map(({ bookmark, ...playableItem }) => {
      const playable = creatorEntityStore(playableItem) as Program;
      if (playable.isProgramRecord && playable.record) {
        playable.record.bookmark = bookmark;
      } else {
        playable.bookmark = bookmark;
      }
      return playable;
    });

    // TODO try change concat to push for all rails (rerender issue)
    this.innerItems = this.innerItems.concat(newItems);

    return { items: this.items, totalCount: newRailData.totalCount, newItems };
  }

  protected async getAdditionData(itemsInPage: PlayableAsset[]): Promise<void> {
    addRentalAttribute(itemsInPage, false);
    addPurchasableAttribute(itemsInPage, false);
  }

  @action
  protected async restoreAdditionData(pageIndex: number, items: PlayableAsset[]) {
    const itemsInPage = getItemsInPage(this.items, pageIndex) as PlayableAsset[];
    addRentalAttribute(itemsInPage, false);
    addPurchasableAttribute(itemsInPage, false);
    await Promise.all([addBookmarkToPlayable(itemsInPage)]);
  }
}
